import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <g>
                    <path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7Z" />
                    <rect x="33.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M82.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S53.4,99.8,56,104.5s10.7,5.4,18,1.6S84.9,95.4,82.2,90.7Z" />
                    <rect x="81.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="33" y="23" width="50" height="10" />
                <rect x="33" y="37" width="21" height="10" />
                <circle cx="92" cy="96" r="4" />
            </g>
        </svg>
    );
}
